import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './SampleBadge.css';

export const SAMPLE_TOOLTIP = "Namuna ma'lumot. Backend tayyor bo'lgach haqiqiysi bilan almashtiriladi.";

// Yasama (namuna) ma'lumot belgisi: Card / StatCard / jadval sarlavhasida ko'rsatiladi.
// Tooltip — sichqoncha ustiga kelganda yoki klaviatura bilan fokusda.
const SampleBadge = forwardRef(function SampleBadge({ label = 'Namuna', className, ...rest }, ref) {
  return (
    <span
      {...rest}
      ref={ref}
      tabIndex={0}
      role="note"
      aria-label={`${label}: ${SAMPLE_TOOLTIP}`}
      title={SAMPLE_TOOLTIP}
      data-tooltip={SAMPLE_TOOLTIP}
      className={cx('ui-sample-badge', className)}
    >
      {label}
    </span>
  );
});

export default SampleBadge;
